import { useAuthentication, OnboardingGuideRegister } from '@ecosystem/newron-client-lib'
import { getAccessModules } from 'components/MarketAccessQuery/useMarketAccessQuery'
import { useEffect } from 'react'
import { ActionableDataSlide } from '../actionable-data-slide/ActionableDataSlide'
import { FocusMattersSlide } from '../focus-matters-slide/FocusMattersSlide'
import { MillionsShoppersSlide } from '../millions-shoppers-slide/MillionsShoppersSlide'
import { SellingStartsSlide } from '../selling-starts-slide/SellingStartsSlide'

export const useRegisterSlides = (): void => {
  const { isAuthenticated, getAccessToken } = useAuthentication()

  useEffect(() => {
    if (!isAuthenticated) {
      return
    }

    if (isAuthenticated) {
      // eslint-disable-next-line @typescript-eslint/no-extra-semi
      ;(async () => {
        const token = await getAccessToken()
        const modules = await getAccessModules(token as string)

        const hasRegisteredCie = OnboardingGuideRegister?.getInstance()
          ?.getAll()
          .filter(({ domain }) => domain === 'cie').length

        // tslint:disable-next-line: no-unused-expression
        modules.includes('cie') &&
          !hasRegisteredCie &&
          OnboardingGuideRegister?.getInstance().register({
            domain: 'cie',
            order: 300,
            component: [
              SellingStartsSlide,
              MillionsShoppersSlide,
              FocusMattersSlide,
              ActionableDataSlide,
            ],
          })
      })()
    }
  }, [getAccessToken, isAuthenticated])
}
